const createTVSImageId = (id, category) => {
    if (!id || id.length === 0) {
        return null;
    }

    if (id.match(/^https?:\/\//)) {
        return id;
    }

    const dotidx = id.lastIndexOf('.');
    // eslint-disable-next-line prefer-template
    return '//d2vi7675edpfss.cloudfront.net/'
        + category
        + '/'
        + id.substring(0, dotidx)
        + '.'
        + '0x0-xhdpi-normal'
        + id.substring(dotidx, id.length);
};

export default createTVSImageId;



// WEBPACK FOOTER //
// ./src/lib/cdn-image-urls.jsx